import { RouteName } from './route-names';
const routesMetaData = {
    [RouteName.Main]: {
        title: 'store_locator.main.meta.title',
        description: 'store_locator.main.meta.description',
    },
    [RouteName.AllStoresWithParameter]: {
        title: 'store_locator.stores.all.meta.title',
        description: 'store_locator.stores.all.meta.description',
        parentRouteName: RouteName.Main,
    },
    [RouteName.AllStores]: {
        title: 'store_locator.stores.all.meta.title',
        description: 'store_locator.stores.all.meta.description',
        parentRouteName: RouteName.Main,
    },
    [RouteName.IqosStores]: {
        title: 'store_locator.stores.iqos.meta.title',
        description: 'store_locator.stores.iqos.meta.description',
        parentRouteName: RouteName.Main,
    },
    [RouteName.PartnerStores]: {
        title: 'store_locator.stores.partner.meta.title',
        description: 'store_locator.stores.partner.meta.description',
        parentRouteName: RouteName.Main,
    },
    [RouteName.ResellerStores]: {
        title: 'store_locator.stores.reseller.meta.title',
        description: 'store_locator.stores.reseller.meta.description',
        parentRouteName: RouteName.Main,
    },
    [RouteName.User]: {
        title: 'store_locator.user.meta.title',
        description: 'store_locator.user.meta.description',
        parentRouteName: RouteName.Main,
    },
    [RouteName.Recharge]: {
        title: 'store_locator.recharge.meta.title',
        description: 'store_locator.recharge.meta.description',
        parentRouteName: RouteName.User,
    },
    [RouteName.Maintenance]: {
        title: 'store_locator.maintenance.meta.title',
        description: 'store_locator.maintenance.meta.description',
        parentRouteName: RouteName.User,
    },
    [RouteName.Clean]: {
        title: 'store_locator.clean.meta.title',
        description: 'store_locator.clean.meta.description',
        parentRouteName: RouteName.User,
    },
    [RouteName.Customize]: {
        title: 'store_locator.customize.meta.title',
        description: 'store_locator.customize.meta.description',
        parentRouteName: RouteName.User,
    },
    [RouteName.Accessories]: {
        title: 'store_locator.accessories.meta.title',
        description: 'store_locator.accessories.meta.description',
        parentRouteName: RouteName.Customize,
    },
    [RouteName.Engraving]: {
        title: 'store_locator.engraving.meta.title',
        description: 'store_locator.engraving.meta.description',
        parentRouteName: RouteName.Customize,
    },
    [RouteName.BuyHeets]: {
        title: 'store_locator.buy-heets.meta.title',
        description: 'store_locator.buy-heets.meta.description',
        parentRouteName: RouteName.User,
    },
    [RouteName.BuyTerea]: {
        title: 'store_locator.buy-terea.meta.title',
        description: 'store_locator.buy-terea.meta.description',
        parentRouteName: RouteName.User,
    },
    [RouteName.BuyFiit]: {
        title: 'store_locator.buy-fiit.meta.title',
        description: 'store_locator.buy-fiit.meta.description',
        parentRouteName: RouteName.User,
    },
    [RouteName.BuyIqos]: {
        title: 'store_locator.buy-iqos.meta.title',
        description: 'store_locator.buy-iqos.meta.description',
        parentRouteName: RouteName.Main,
    },
    [RouteName.BuyLilSolidEz]: {
        title: 'store_locator.buy-lil-solid-ez.meta.title',
        description: 'store_locator.buy-lil-solid-ez.meta.description',
        parentRouteName: RouteName.Main,
    },
    [RouteName.New]: {
        title: 'store_locator.new.meta.title',
        description: 'store_locator.new.meta.description',
        parentRouteName: RouteName.Main,
    },
    [RouteName.LendIqos]: {
        title: 'store_locator.lend-iqos.meta.title',
        description: 'store_locator.lend-iqos.meta.description',
        parentRouteName: RouteName.New,
    },
    [RouteName.Contact]: {
        title: 'store_locator.contact.meta.title',
        description: 'store_locator.contact.meta.description',
        parentRouteName: RouteName.Main,
    },
    [RouteName.SubmitQuestion]: {
        title: 'store_locator.question.meta.title',
        description: 'store_locator.question.meta.description',
        parentRouteName: RouteName.Contact,
    },
};
export default routesMetaData;
